module.exports = __webpack_public_path__ + "img/ic_facebook_bg_black.088f8228.svg";